"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rewriteValueNumber = void 0;
var itemList_1 = require("../lib/itemList");
var rewriteValueNumber = function () {
    console.log('rewriteValueNumber');
    var observer = new MutationObserver(function (mutations) {
        var _a;
        var _loop_1 = function (mutation) {
            // 項目名
            var unitPriceElement = document.querySelector('select[name="input_1"]');
            // 数量
            var unitElement = document.querySelector('input[name="input_3"]');
            // 自動計算のinput
            var autoCalcuElement = document.querySelector('input[name="input_5"]');
            if (unitPriceElement !== null && unitElement !== null) {
                // 選択された項目の単位をコピーするinput(単位も送信するために必要)
                var unitAddInput = document.querySelector('.unit_label_copy input');
                // 選択された項目の単位を表示するlabel
                var unitLabel = document.querySelector('.unit_label label');
                // セレクトエリアの選択された項目のindexを取得
                var index = unitPriceElement.selectedIndex;
                // 選択された項目のテキストを取得
                var text = unitPriceElement.options[index].text;
                // lineItemsから一致する項目を探す
                for (var _b = 0, lineItems_1 = itemList_1.lineItems; _b < lineItems_1.length; _b++) {
                    var item = lineItems_1[_b];
                    if (text.includes(item.specification)) {
                        var unitValue = item.unit === 'ｍ' ? 'm' : item.unit;
                        unitAddInput.value = unitValue; // 選択された項目の単位をコピーするinput
                        unitLabel.textContent = unitValue; // 単位を表示するlabel
                        break; // 選択された項目を見つけたらループを終了(一致する項目が複数個あるため)
                    }
                }
            }
            // 施工時間を`localStorage`から取得する関数
            var getConstructionTime = function () {
                var constructionTime = localStorage.getItem('Construction_time');
                return constructionTime === '1' ? 1.2 : 1; // 夜間であれば、1.2倍にする
            };
            var getPavementType = function () {
                var pavementType = localStorage.getItem('Pavement_type');
                switch (pavementType) {
                    case '0':
                        return 1;
                    case '1':
                        return 1.2;
                    case '2':
                        return 1.1;
                    default:
                        return 1;
                }
            };
            var calculateResult = function () {
                var unitPrice = Number.parseFloat(unitPriceElement.value);
                var unit = Number.parseFloat(unitElement.value);
                var magnification = getConstructionTime();
                var pavementType = getPavementType();
                // ここで乗算と`autoCalcuElement`の値の更新を行う
                if (!Number.isNaN(unitPrice) && !Number.isNaN(unit)) {
                    var result = unitPrice * unit * magnification;
                    var roundedNumber = Math.round(result);
                    autoCalcuElement.value = roundedNumber.toString();
                }
            };
            var changeUnitLabel = function (text) {
                var label01 = document.querySelector('.unit_label label');
                var handleUnitElement = function (label, lineItems, unitElement) {
                    var _a;
                    if (label !== null) {
                        for (var _i = 0, lineItems_2 = lineItems; _i < lineItems_2.length; _i++) {
                            var item = lineItems_2[_i];
                            if (text.includes(item.specification)) {
                                var existingCautionText = (_a = label.parentNode) === null || _a === void 0 ? void 0 : _a.querySelector('.gfield_description.instruction');
                                if (existingCautionText !== null) {
                                    existingCautionText.remove();
                                }
                                label.textContent = item.unit;
                                if (item.specification === '区画線消去　削り取り式　45ｍ未満') {
                                    // const cautionText = document.createRange()
                                    //   .createContextualFragment(`
                                    //   <div>
                                    //     <strong>1</strong>から<strong>1</strong>までの数字を入力してください。
                                    //   </div>
                                    // `)
                                    // label.parentNode?.appendChild(cautionText)
                                    unitElement.min = '1';
                                    unitElement.max = '1';
                                    unitElement.readOnly = true;
                                    unitElement.value = '1';
                                }
                                else {
                                    unitElement.min = '';
                                    unitElement.max = '';
                                    unitElement.readOnly = false;
                                    unitElement.value = '';
                                }
                                break;
                            }
                        }
                    }
                };
                handleUnitElement(label01, itemList_1.lineItems, unitElement);
            };
            // unitPriceElementとunitElementのchangeイベントリスナーを追加
            for (var _c = 0, _d = [unitPriceElement, unitElement]; _c < _d.length; _c++) {
                var element = _d[_c];
                if (element === null)
                    return { value: void 0 };
                element.addEventListener('change', calculateResult);
            }
            var _loop_2 = function (element) {
                if (element === null)
                    return { value: void 0 };
                element.addEventListener('change', function () {
                    var index = element.selectedIndex;
                    var text = element.options[index].text;
                    changeUnitLabel(text);
                });
            };
            for (var _e = 0, _f = [unitPriceElement]; _e < _f.length; _e++) {
                var element = _f[_e];
                var state_2 = _loop_2(element);
                if (typeof state_2 === "object")
                    return state_2;
            }
            calculateResult();
            if (unitPriceElement !== null && unitElement !== null) {
                changeUnitLabel(unitElement.value);
            }
            setTimeout(function () {
                var _a, _b;
                if (mutation.addedNodes.length > 0) {
                    // 全ての.unit_labelクラスを持つ要素を取得
                    var unitLabels = document.querySelectorAll('.unit_label label');
                    // unit_label_copyのinput要素を取得
                    var unitLabelCopyInput_1 = document.querySelector('.unit_label_copy input');
                    if (unitLabelCopyInput_1 !== null) {
                        unitLabelCopyInput_1.value = (_b = (_a = unitLabels[0]) === null || _a === void 0 ? void 0 : _a.textContent) !== null && _b !== void 0 ? _b : '';
                    }
                    var _loop_3 = function (unitLabel) {
                        // unit_label内のinput要素を取得
                        var input = unitLabel.querySelector('input[type="number"]');
                        if (input === null)
                            return { value: void 0 };
                        // input要素にイベントリスナーを設定
                        input.addEventListener('change', function () {
                            var _a;
                            // input要素の値がある場合
                            if (input.value !== '') {
                                // 対応するラベルのテキストを取得
                                var label = unitLabel.querySelector('label');
                                if (label !== null) {
                                    var labelText = (_a = label.textContent) !== null && _a !== void 0 ? _a : '';
                                    // unit_label_copyのinputにラベルのテキストを設定
                                    unitLabelCopyInput_1.value = labelText;
                                }
                            }
                            else {
                                // 入力がない場合はunit_label_copyの値をクリア
                                unitLabelCopyInput_1.value = '';
                            }
                        });
                    };
                    // 各unit_label要素に対する処理
                    for (var _i = 0, _c = Array.from(unitLabels); _i < _c.length; _i++) {
                        var unitLabel = _c[_i];
                        var state_3 = _loop_3(unitLabel);
                        if (typeof state_3 === "object")
                            return state_3.value;
                    }
                }
            }, 100);
            if (mutation.addedNodes.length > 0) {
                var selectElements = document.querySelectorAll('.box-label .gfield_select');
                for (var _g = 0, _h = Array.from(selectElements); _g < _h.length; _g++) {
                    var selectElement = _h[_g];
                    var target = selectElement;
                    if (target !== null) {
                        var selectedOptionLabel = target.options[target.selectedIndex].text;
                        var hiddenInput = (_a = target
                            .closest('.gform_fields')) === null || _a === void 0 ? void 0 : _a.querySelector('.input_label_copy input');
                        if (hiddenInput !== null) {
                            hiddenInput.value = selectedOptionLabel;
                        }
                    }
                }
            }
        };
        for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
            var mutation = mutations_1[_i];
            var state_1 = _loop_1(mutation);
            if (typeof state_1 === "object")
                return state_1.value;
        }
    });
    // .mikado-formsクラスを持つすべての要素を監視
    var targetNodes = document.querySelectorAll('.mikado-forms');
    var config = { childList: true, subtree: true };
    for (var _i = 0, _a = Array.from(targetNodes); _i < _a.length; _i++) {
        var targetNode = _a[_i];
        observer.observe(targetNode, config);
    }
    document.addEventListener('change', function (event) {
        var _a;
        var target = event.target;
        if (target === null || target === void 0 ? void 0 : target.matches('.box-label .gfield_select')) {
            var selectedOptionLabel = target.options[target.selectedIndex].text;
            var hiddenInput = (_a = target
                .closest('.gform_fields')) === null || _a === void 0 ? void 0 : _a.querySelector('.input_label_copy input');
            if (hiddenInput !== null) {
                hiddenInput.value = selectedOptionLabel;
                // updateDisplayBasedOnLabel(selectedOptionLabel)
            }
        }
    });
};
exports.rewriteValueNumber = rewriteValueNumber;
